<login *ngIf="pageType == 0"></login>

<div *ngIf="userSession.showMenuTop && (pageType == 1 || pageType == 2)" class="test desktop_header2">
  <div class="navbar navbar-inverse topmenu">
        <div class="navbar-header">
             <div class="toggle-button">
                  <a id="toggle" (click)="toggleMenu()"><span></span></a>
            </div>
            <div class="navbar-brand">
                <a class="navbar-brand-logo" [routerLink]="">FabianNet</a>
            </div>
        </div>
          <div class="topnav">
              <div class="topnav-inner">
                  <a class="active" href="#home">Home</a>
                  <a href="#news">News</a>
                  <a href="#contact">Contact</a>
                  <a href="#about">About</a>
              </div>
              
          </div>
          <a *ngIf="userSession.showUserDropdown" [routerLink]="" (click)="presentPopover($event)" >
              <div class="profile-box">
                  <div class="profile-box-avatar">
                      <img *ngIf="!userSession.avatarUrl" src="assets/img/Kelvin2.png"/>
                      <img *ngIf="userSession.avatarUrl" [src]="userSession.avatarUrl | authImage | async"/>
                  </div>
                  <ion-icon name="chevron-down-outline"></ion-icon>
              </div>
          </a>
  </div>
</div>

<ion-split-pane *ngIf="pageType != 0" style="height: 100%;" disabled="true" contentId="main">
  <ion-menu *ngIf="userSession.showSideMenu" auto-hide="true" type="overlay" contentId="main">

    <ion-content>
      <div *ngIf="userSession.showSideMenu" class="g-side-bar" style="height: 1800px; width: 500px">
        <nav class="navbar navbar-dark ">
          <div class="navbar-collapse" id="navbarNav">
            <ul class="navbar-nav" *ngFor="let p of userSession.appPages">
              <li class="nav-item">
                <a class="nav-link" [routerLink]="[p.url]" ><ion-icon name="{{p.icon}}"></ion-icon>{{p.name}}</a>
              </li>
            </ul>
            <ul class="navbar-nav">
              <li class="nav-item">
                <a class="nav-link" [routerLink]="['login']" ><ion-icon name=""></ion-icon>login</a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    
    </ion-content>
  </ion-menu>

  <div class="ion-page gbr-background" id="main">
    <ion-router-outlet [ngClass]="userSession.showSideMenu ? 'menu-space' : ''" main></ion-router-outlet>
  </div>
</ion-split-pane>